/**
 * 打开专属客服：新 H5 客服（带会员 ID），兼容后台 kefu_contact.url。
 */
import {
  buildKefuChatUrl,
  openKefuChatUrl,
  resolveMemberId,
} from "@/common/kefuChat";

export function getKefuContact(baseInfo) {
  const info = baseInfo || {};
  const contact = info.kefu_contact || {};
  const url = contact.url || info.kefu || "";
  return {
    mode: contact.mode || "contact_only",
    title: contact.title || "",
    action_text: contact.action_text || "",
    enabled: contact.enabled == null ? 1 : Number(contact.enabled),
    url,
    name: contact.name || "",
  };
}

function appendMemberIdToUrl(url, userId) {
  if (!url || !userId) {
    return url;
  }
  try {
    const parsed = new URL(url, window.location.origin);
    // 已有 visitorId / userId 则不覆盖
    if (
      parsed.searchParams.get("visitorId") ||
      parsed.searchParams.get("userId") ||
      (parsed.searchParams.get("userParams") || "").indexOf("visitorId") !== -1
    ) {
      return parsed.toString();
    }
    if (parsed.pathname.indexOf("/chat") !== -1 || parsed.searchParams.get("channelId")) {
      return buildKefuChatUrl(userId, {
        baseUrl: `${parsed.origin}${parsed.pathname}`,
        channelId: parsed.searchParams.get("channelId") || undefined,
      });
    }
    parsed.searchParams.set("userId", String(userId));
    parsed.searchParams.set("visitorId", String(userId));
    return parsed.toString();
  } catch (error) {
    const join = url.indexOf("?") >= 0 ? "&" : "?";
    return `${url}${join}userId=${encodeURIComponent(userId)}&visitorId=${encodeURIComponent(userId)}`;
  }
}

export async function openKefuContact(vm, options = {}) {
  if (vm && vm.$toast && !options.silent) {
    vm.$toast.loading({
      message: options.loadingText || "正在连接客服…",
      forbidClick: true,
      duration: 0,
    });
  }

  try {
    let userId = String(options.userId || resolveMemberId(vm) || "").trim();
    // 已登录但本地还没有 ID 时，补拉一次会员信息
    if (!userId && vm && vm.$http && localStorage.getItem("token")) {
      try {
        const res = await vm.$http({ method: "get", url: "user_info" });
        if (res && res.code === 200 && res.data) {
          if (vm.$store && vm.$store.commit) {
            vm.$store.commit("setUserInfoValue", res.data);
          }
          userId = String(res.data.id || res.data.user_id || res.data.uid || "").trim();
        }
      } catch (error) {
        // ignore
      }
    }

    const store = vm && vm.$store;
    const baseInfo = (store && store.getters && store.getters.getBaseInfo) || {};
    const contact = getKefuContact(baseInfo);

    // 优先：固定新客服 H5 + 会员 ID；options.url 显式传入时仍尊重并补 ID
    let url = "";
    if (options.url) {
      url = appendMemberIdToUrl(options.url, userId);
    } else if (!options.skipDefaultChat) {
      url = buildKefuChatUrl(userId);
    } else if (contact.url) {
      url = appendMemberIdToUrl(contact.url, userId);
    }

    if (url) {
      if (vm && vm.$toast) {
        vm.$toast.clear();
      }
      openKefuChatUrl(url, options);
      return true;
    }

    if (vm && vm.$router && !options.skipFallbackRoute) {
      if (vm && vm.$toast) {
        vm.$toast.clear();
      }
      vm.$router.push(options.fallbackPath || "/ServiceOnline");
      return true;
    }

    if (vm && vm.$toast) {
      vm.$toast.clear();
    }
    return false;
  } catch (error) {
    if (vm && vm.$toast) {
      vm.$toast.clear();
    }
    return false;
  }
}

export function resolveLanguageOptions(baseInfo, fallbackOptions) {
  const allowed = fallbackOptions || [];
  const list = (baseInfo && Array.isArray(baseInfo.lang_list) && baseInfo.lang_list) || [];
  if (!list.length) {
    return allowed;
  }

  const byCode = {};
  allowed.forEach((item) => {
    byCode[item.code] = item;
    byCode[item.appLang] = item;
  });

  const mapped = list
    .map((item) => {
      const code = item.code || item.lang || item.value;
      const known = byCode[code];
      if (!known) {
        return null;
      }
      return {
        ...known,
        fullLabel: item.name || known.fullLabel,
        label: known.label,
      };
    })
    .filter(Boolean);

  const present = new Set(mapped.map((item) => item.code));
  allowed.forEach((item) => {
    if (!present.has(item.code)) {
      mapped.push(item);
    }
  });

  return mapped.length ? mapped : allowed;
}
